import * as React from 'react';
export var GroupCourseListContext = React.createContext([]);
export var GroupCourseListProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(), GroupCourseList = _b[0], setGroupCourseList = _b[1];
    var value = [GroupCourseList, setGroupCourseList];
    return React.createElement(GroupCourseListContext.Provider, { value: value }, children);
};
